import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaDecisionTemplatesMenuRegistry = {
    personalize_nebulaDecisionTemplates: {
        label: "Nebula Decision Templates",
        link: PAGE_URL.NEBULA_DECISION_TEMPLATES_PAGE,
        key: PAGE_URL.NEBULA_DECISION_TEMPLATES_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaDecisionTemplatesMenuRegistry;
